import { __extends, __spreadArray } from "tslib";
import * as React from 'react';
import { classNames } from '@wix/answers-lib';
import { Icon } from '../../icon/icon';
import { ComponentsViewer } from '../../components-viewer.comp';
import favouriteIcon from './favourite-icn.svg';
export var TOTAL_CELL_PADDING = 50;
var removeEmptyHTMLTags = function (content) { return content.replace(/(<([^>]+)>)/gi, ''); };
var isEmptyContent = function (components) { return !components.length ||
    components.filter(function (component) { return (component.type === 'text') &&
        removeEmptyHTMLTags(component.value.html).length === 0; }).length === components.length; };
var TabsComponent = /** @class */ (function (_super) {
    __extends(TabsComponent, _super);
    function TabsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.recommendedTab = _this.props.value.recommendedTab;
        _this.findSelectedSlugIndex = function (slugsInURL) {
            return _this.props.value.slugs.findIndex(function (slug) { return slugsInURL.includes(slug); });
        };
        _this.maybeGetSelectedTabOnLoad = function () {
            var slugs = _this.props.selectedTabsOnLoad;
            if (slugs) {
                var selectedIndex = _this.findSelectedSlugIndex(slugs);
                return selectedIndex > -1 ? selectedIndex : null;
            }
            return null;
        };
        _this.isEmpty = function (heading, contents) { return heading.length === 0 || isEmptyContent(contents); };
        _this.isRecommendedNotEmpty = _this.recommendedTab !== undefined &&
            !_this.isEmpty(_this.props.value.headings[_this.recommendedTab], _this.props.value.contents[_this.recommendedTab]);
        _this.nonEmptyTabsIdxs = _this.props.value.headings.map(function (heading, idx) {
            if (!_this.isEmpty(heading, _this.props.value.contents[idx])) {
                return idx;
            }
            return undefined;
        }).filter(function (x) { return x !== undefined; });
        _this.state = { selectedTab: _this.isRecommendedNotEmpty ? _this.recommendedTab : _this.nonEmptyTabsIdxs[0] };
        _this.onHeaderClick = function (selectedTab) {
            _this.setState({ selectedTab: selectedTab });
            if (_this.props.onTabClick) {
                _this.props.onTabClick(selectedTab, _this.props.value.slugs || []);
            }
        };
        return _this;
    }
    TabsComponent.prototype.componentDidMount = function () {
        var maybeSelectedTabOnLoad = this.maybeGetSelectedTabOnLoad();
        if (maybeSelectedTabOnLoad !== null) {
            this.setState({ selectedTab: maybeSelectedTabOnLoad });
        }
    };
    TabsComponent.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var _a = props.value, headings = _a.headings, contents = _a.contents;
        var headingComps = headings.map(function (heading, idx) {
            if (_this.isEmpty(heading, contents[idx])) {
                return null;
            }
            var isTabSelected = _this.state.selectedTab === idx;
            var isTabRecommneded = props.value.recommendedTab === idx;
            var className = classNames('tab-heading', "heading-".concat(idx), { 'selected': isTabSelected }, { 'recommended': isTabRecommneded });
            var onHeaderClick = function () { return _this.onHeaderClick(idx); };
            return (React.createElement("div", { key: idx, className: className, onClick: onHeaderClick },
                React.createElement("div", { className: 'heading-ellipsis' }, heading),
                isTabRecommneded ? React.createElement(Icon, { dangerouslyDisableSanitation: true, className: 'recommended-tab-icon', icon: favouriteIcon }) : null));
        });
        var tabsHeadingsLTR = function () { return (React.createElement("div", { className: 'tab-headings' },
            headingComps,
            React.createElement("div", { className: 'filler-heading' }))); };
        var tabsHeadingsRTL = function () {
            var reversedHeadings = headingComps && __spreadArray([], headingComps, true).reverse();
            return (React.createElement("div", { className: 'tab-headings' },
                React.createElement("div", { className: 'filler-heading' }),
                reversedHeadings));
        };
        var selectedTab = this.state.selectedTab || 0;
        var tabsContents = (React.createElement("div", { className: 'tab-contents' },
            React.createElement(ComponentsViewer, { components: contents.length > 0 ? contents[selectedTab] : [], locale: props.locale })));
        return (React.createElement("div", { className: classNames('component', 'tabs-component', this.props.direction), "data-component-type": 'tabs' },
            React.createElement("div", { className: 'tabs-wrapper' },
                React.createElement("div", { className: 'tabs-inner' },
                    this.props.direction === 'rtl' ? tabsHeadingsRTL() : tabsHeadingsLTR(),
                    tabsContents))));
    };
    return TabsComponent;
}(React.Component));
export { TabsComponent };
//# sourceMappingURL=tabs-component.comp.js.map